import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { queryKeys } from "@/lib/react-query";
import { personalizationService } from "../services/personalization";
import type { Board, Class, State } from "../types/auth.types";

const DEFAULT_OPTIONS = {
  staleTime: 1000 * 60 * 10,
  gcTime: 1000 * 60 * 30,
  refetchOnWindowFocus: false,
} as const;

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  return "An unexpected error occurred";
}

export function usePersonalizationStates(
  options?: Omit<UseQueryOptions<State[], Error>, "queryKey" | "queryFn">,
) {
  return useQuery({
    queryKey: queryKeys.personalization.states(),
    queryFn: async () => personalizationService.getStates(),
    ...DEFAULT_OPTIONS,
    ...options,
  });
}

export function usePersonalizationBoards(
  options?: Omit<UseQueryOptions<Board[], Error>, "queryKey" | "queryFn">,
) {
  return useQuery({
    queryKey: queryKeys.personalization.boards(),
    queryFn: async () => personalizationService.getBoards(),
    ...DEFAULT_OPTIONS,
    ...options,
  });
}

export function usePersonalizationClasses(
  options?: Omit<UseQueryOptions<Class[], Error>, "queryKey" | "queryFn">,
) {
  return useQuery({
    queryKey: queryKeys.personalization.classes(),
    queryFn: async () => personalizationService.getClasses(),
    ...DEFAULT_OPTIONS,
    ...options,
  });
}

export { getErrorMessage };
